export default __webpack_public_path__ + "static/media/logo_ePayco.1785776060741.png";